import {STATISTICS} from '../constants/statistics';

export const optimizeKarts = (karts) => {
  const lookups = buildKartLookups(karts);

  return karts.filter((k) => kartIsOptimal(k, karts, lookups));
};

// lookups[stat index][score index] = [indexes of karts having (at least) the given score for the given stat]
const buildKartLookups = (karts) => {
  const lookups = buildEmptyKartLookups();
  karts.forEach((k, i) => addKartToLookups(i, k, lookups));
  return lookups;
};

const buildEmptyKartLookups = () => {
  const lookups = [];
  const maxScoreIndex = 5.75 * 4; // Convert float scores to integer score indexes.

  STATISTICS.forEach((stat) => {
    lookups[stat.index] = [];

    for (let scoreIndex = 0; scoreIndex <= maxScoreIndex; scoreIndex++) {
      lookups[stat.index][scoreIndex] = [];
    }
  });

  return lookups;
};

const addKartToLookups = (kartIdx, kart, lookups) => {
  STATISTICS.forEach((stat) => {
    addKartToLookup(kartIdx, kart, lookups[stat.index], stat);
  });
};

const addKartToLookup = (kartIdx, kart, lookup, stat) => {
  const kartScore = kart.stats[stat.index];
  const integerizedKartScore = kartScore * 4;

  for (let score = 0; score <= integerizedKartScore; score++) {
    lookup[score].push(kartIdx);
  }
};

const kartIsOptimal = (kart, otherKarts, lookups) => {
  for (const kartIdx of shortestCompetitorList(lookups, kart)) {
    const otherKart = otherKarts[kartIdx];

    if (kartBeatsKart(otherKart, kart)) {
      return false;
    }
  }

  return true;
};

// Given a kart, returns a list of kart lookups that may be superior to the
// argument kart.  Returns the list based on a single dimension, picking the
// dimension and corresponding score threshold based on kart, that eliminates
// the most candidates.
const shortestCompetitorList = (lookups, kart) => {
  let result;

  STATISTICS.forEach((stat) => {
    const kartScore = kart.stats[stat.index];
    const integerizedKartScore = kartScore * 4;
    const competitorList = lookups[stat.index][integerizedKartScore];

    if (!result || competitorList.length < result.length) {
      result = competitorList;
    }
  });

  return result;
};

const kartBeatsKart = (kart1, kart2) => {
  let hasEdge = false;

  for (const stat of STATISTICS) {
    if (kart1.stats[stat.index] < kart2.stats[stat.index]) { return false; }
    if (kart1.stats[stat.index] > kart2.stats[stat.index]) { hasEdge = true; }
  }

  return hasEdge;
};
